import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './DepthCheck.module.scss';

interface Props {
  depthOutliers?: number;
  bitdepOutliers?: number;
  className?: string;
}

const DepthCheck: React.FC<Props> = ({ depthOutliers, bitdepOutliers, className }) => {
  const getDepthOutlier = () => {
    if (depthOutliers === null || depthOutliers === undefined) {
      return (
        <div className={styles.red}>
          <FormattedMessage id="dataManagement.dataQuality.dataConsistency.depthCheck.depthFailure" />
        </div>
      );
    }

    return (
      <div>
        <span className={depthOutliers > 10 ? styles.red : styles.green}>{depthOutliers} </span>
        <FormattedMessage id="dataManagement.dataQuality.dataConsistency.depthCheck.depth" />
      </div>
    );
  };

  const getBitDepthOutlier = () => {
    if (bitdepOutliers === null || bitdepOutliers === undefined) {
      return (
        <div className={styles.red}>
          <FormattedMessage id="dataManagement.dataQuality.dataConsistency.depthCheck.bitdepFailure" />
        </div>
      );
    }

    return (
      <div>
        <span className={bitdepOutliers > 10 ? styles.red : styles.green}>{bitdepOutliers} </span>
        <FormattedMessage id="dataManagement.dataQuality.dataConsistency.depthCheck.bitdep" />
      </div>
    );
  };

  return (
    <div className={className}>
      <div className={styles.title}>
        <FormattedMessage id="dataManagement.dataQuality.dataConsistency.depthCheck.title" />
      </div>
      {getDepthOutlier()}
      {getBitDepthOutlier()}
    </div>
  );
};

export default DepthCheck;
